module.exports = __webpack_public_path__ + "img/Uppeer_level-image.1eeef792.png";